module.exports = __webpack_public_path__ + "static/media/Nikto-logo.4aac1d40.png";